import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import { useFormik, FormikProvider, FieldArray } from "formik";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from '../Global';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const StockInventoryEdit = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);
  const [statusOptions, setStatusOptions] = useState([]);
  const [locationLoading, setLocationLoading] = useState([]);
  const [valueContents, setValueContents] = useState([]);
    const [permission, setPermission] = useState({});
  
  const [showTableHeadings, setShowTableHeadings] = useState(false);
  useEffect(() => {
        setPermission(FindModuleById(161)); 
console.log(permission);

    axios
      .get(`/stock-inventories/edit/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
       // setBackendErrors(response.data.data.Stock);
        setValue(response.data.data.Stock);
        setValueContents(response.data.data.Stock.items);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const formik = useFormik({
    initialValues: {
      id: value.id,
      date: value.date,
      location:value.location,
      contents: valueContents,
    },
    enableReinitialize: true,

    onSubmit:(values , { setSubmitting }) => { axios  .post("/stock-inventories/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          delete backendErrors['error'];
          setSubmitting(false);
          $("#form-submit").text("Update Stock Inventory");
          if (response.data.code === 200) {
            toast.success(response.data.message);
            
           // toast.success(response.data.message);
          //  actions.resetForm();
            setTimeout(() => {
              window.location.href = "/stock-inventories";
            }, 1000);
          }  else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  useEffect(() => {

    axios.post("/consumables/listing",{}, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    })
    .then((response) => {
      if(response.data.code === 200){
        let supplier_types = response.data.data.products;
           // setPackagingTypesLists(materials_payment_status);
            let supplier_typesList = supplier_types.map((ord, index) => ({
              label:  ord.consumable_name ,
              value: ord.id,
              key: `supplier-${index}`,
            }));
            setStatusOptions(supplier_typesList);
    }else{
        console.log("API response is not an array");
      }
              
    })
    .catch((error) => {
      console.log(error);
    });

    
    axios
    .get(`/helpers/loading-locations`, {
      headers: {
        Authorization: `Bearer ${Authtoken}`,
        Apitoken: Apitoken,
      },
    })
    .then((response) => {
      if (response.data.code === 200) {
        let locations = response.data.data.locations;
        let locationslisting = locations.map((ord, index) => ({
          label: ord.title,
          value: ord.id,
          key: `location-${index}`,
        }));
        setLocationLoading(locationslisting); 
      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });

}, []);

const customHandleInput = (event) => {
  const Input_name = event.target.name;
  delete backendErrors[Input_name];
};

const handleSelectChange = (name, selectedOption) => {
  const value = selectedOption ? selectedOption.value : "";
  updateFormikValue(name, value);
  customHandleInput({ target: { name, value } });
};

const updateFormikValue = (name, value) => {
  formik.setFieldValue(name, value);
};
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /> <ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Stock Inventories</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/stock-inventories">Stock Inventories</Link>
                    </li>
                    <li className="breadcrumb-item active">Edit</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Stock Inventories </h4>
                    {permission && permission.update === 1 && (
                    <FormikProvider value={formik}>

                    <form action="#" onSubmit={formik.handleSubmit}>
                    <div className="row">
                        <div className="col-md-3">
                        <div className="form-group status">
                           <label>Location</label>
                           {locationLoading.length > 0 && (
                             <Select
                             className="w-100"
                             value={locationLoading.find(option => option.value == formik.values.location) || null} // Ensure correct format
                             name="location"
                             onChange={(selectedOption) => {
                             handleSelectChange("location", selectedOption);
                          //   generateLotNumberLocation(selectedOption.value);
                             }}
                             onBlur={formik.handleBlur}
                             options={locationLoading}
                             placeholder="Select"
                             />
                           )}
                           <small>
                             {backendErrors.location && (
                                 <span className="form-error mt-1">
                                   {backendErrors.location}
                                 </span>
                               )}
                           </small>
                         </div>
                       </div>
                       
                       
                        <div className="col-md-3">
                        <div className="form-group status">
                        <label> Select Date</label>
                        <input
                            type="date"
                            name="date"
                            value={formik.values.date}
                            className="form-input form-control"
                            onChange={(e) => {
                              formik.handleChange(e);
                              customHandleInput(e);
                            }}
                            onBlur={formik.handleBlur}
                          />
                            <small>
                              {backendErrors.date  && (
                                <span className="form-error mt-1">
                                  {backendErrors.date}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                      </div>


        
                      <div className="row">
                          <div className="col-md-6">
                            <h4 className="card-title">
                              <br />
                              Items
                            </h4>
                          </div>
                        </div>
                        <FieldArray
                          name="contents"
                          render={(arrayHelpers) => (
                            <div>
                              <button
                                className="btn btn-primary mb-3"
                                type="button"
                                onClick={() => {
                                //   let appendArr =arrayHelpers.form.values.contents[0];
                                  let initialArr ={
                                    consumable: "",
                                    quantity:"",
                                    note:""
                                 }
                                //    appendArr = (appendArr)?appendArr:initialArr;
                                  arrayHelpers.push(initialArr);
                                  setShowTableHeadings(true);
                                 
                                }}
                              >
                                +
                              </button>

                                {showTableHeadings && (
                                  <div className="row">
                                  {/* <div className="col-md-1">Operation</div>
                                  <div className="col-md-1">Lot Number</div>
                                  <div className="col-md-2">Consomable</div>
                                  <div  className="col-md-1">Currency</div>
                                  <div  className="col-md-2">Amount</div>
                                  <div  className="col-md-1">Qty</div>
                                  <div  className="col-md-3">Delivery Note</div>
                                  <div  className="col-md-1"></div> */}
                              </div>
                                )}
                                
                                {formik.values.contents.map(
                                    (friend, index) => (
                                      <div  className="row" key={index}>
                                        <div  className="col-md-3">
                                          <div className="form-group status">
                                          <label> Consomable</label><br/>
                                          {statusOptions.length > 0 && (
                                            <Select
                                            name={`contents[${index}].consumable`}
                                            options={statusOptions}
                                            value={statusOptions.find(option => option.value == formik.values.contents[index].consumable) || null} // Ensure correct format
                                            onChange={(selectedOption) => {
                                              formik.setFieldValue(`contents[${index}].consumable`, selectedOption.value); // ✅ Store only value in Formik
                                              customHandleInput({
                                                target: {
                                                  name: `contents[${index}].consumable`,
                                                  value: selectedOption.value, // ✅ Ensure only value is passed
                                                },
                                              });
                                            }}
                                            onBlur={formik.handleBlur}
                                            placeholder="Select"
                                            className="w-100" 
                                           
                                            />
                                          )}
                                          
                                            
                                          </div>
                                        </div>
                                       
                                       
                                       
                                        <div  className="col-md-2">
                                          <div className="form-group">
                                          <label>Quanity</label><br/>
                                            <input
                                               type="text"
                                               onKeyPress={(event) => {
                                                 // Allow only numbers (0-9)
                                                 if (!/^[0-9]$/.test(event.key)) {
                                                 event.preventDefault();
                                                 }
                                               }}
                                              placeholder="Enter Quantity"
                                              className="form-input form-control"
                                              name={`contents[${index}].quantity`}
                                              value={
                                                formik.values.contents[index]
                                                  .quantity
                                              }
                                              onChange={formik.handleChange}
                                            />
                                          </div>
                                        </div>
                                      
                                        <div  className="col-md-6">
                                          <div className="form-group">
                                          <label>Note</label><br/>
                                            <input
                                              type="text"
                                              placeholder="Enter Note"
                                              className="form-input form-control"
                                              name={`contents[${index}].note`}
                                              value={
                                                formik.values.contents[index]
                                                  .note
                                              }
                                              onChange={formik.handleChange}
                                            />
                                          </div>
                                        </div>
                                        
                                       
                                        <div  className="col-md-1">
                                          <div className="form-group">
                                            <button
                                              className="btn btn-danger"
                                              // style={{ marginTop: 30 }}
                                              type="button"
                                              onClick={() =>
                                                arrayHelpers.remove(index)
                                              }
                                            >
                                              -
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  )}
                               
                            </div>
                          )}
                        />
                          <small>
                              {backendErrors.status  && (
                                <span className="form-error mt-1">
                                  {backendErrors.status}
                                </span>
                              )}
                            </small>
                           
                             <div className="text-end mt-4">
                                <button
                                  type="submit" id="form-submit"
                                  className="btn btn-primary"
                                  disabled={formik.isSubmitting}
                                >
                                  Update Stock Inventory
                                </button>
                              </div>
                    </form>
                 </FormikProvider>
                  )}

                  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default StockInventoryEdit;
